export const READONLY_MESSAGE =
    "You can input changes on this page but you won't be able to save them because the site is in read-only mode";
